(() => {
  const mediaQuery = window.matchMedia('(max-width: 749px)');

  const getSlides = (gallery) =>
    Array.from(gallery.querySelectorAll('.product__media-item')).filter(
      (slide) => !slide.hasAttribute('hidden')
    );

  const setActiveDot = (dots, index) => {
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('is-active', dotIndex === index);
      dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
    });
  };

  const currentSlideIndex = (list, slides) => {
    const listLeft = list.getBoundingClientRect().left;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - listLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  };

  const initGallery = (gallery) => {
    if (gallery.dataset.tahHommeyGallery === 'true') return;

    const list = gallery.querySelector('.product__media-list');
    const controls = gallery.querySelector('.slider-buttons');

    if (!list || !controls) return;

    const slides = getSlides(gallery);
    if (slides.length < 2) return;

    gallery.dataset.tahHommeyGallery = 'true';

    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'tah-gallery-dots';
    dotsWrap.setAttribute('aria-label', 'Product image gallery');

    const dots = slides.map((slide, index) => {
      const dot = document.createElement('button');
      dot.className = 'tah-gallery-dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show product image ${index + 1}`);

      dot.addEventListener('click', () => {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        setActiveDot(dots, index);
      });

      dotsWrap.appendChild(dot);
      return dot;
    });

    controls.appendChild(dotsWrap);
    setActiveDot(dots, 0);

    let frame = null;
    const update = () => {
      if (!mediaQuery.matches) return;

      if (frame) window.cancelAnimationFrame(frame);

      frame = window.requestAnimationFrame(() => {
        setActiveDot(dots, currentSlideIndex(list, slides));
      });
    };

    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const init = () => {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
